<template>
  <div>

    <div class="title_text">

      <div>
        <Icon type="ios-bookmark" size="18" color="#0466dd" />

        <span class="title_text2">结算数据</span>
      </div>
      <div class="query_box">
        <DatePicker type="month" @on-change="date_change" v-model="current_month" size="small" placement="bottom-end"
          placeholder="选择日期" style="width: 100px" />
      </div>
    </div>

    <div class="data_div">
      <div class="card_main">
        <div class="card_main01">
          <Spin fix v-if="loading"></Spin>

          <div class="count_card3" @click="click_cash_pledge">
            <div class="count_up">
              <CountUp :end="cash_pledge_balances" :decimals="2" duration="3" ref="count" v-font="18" />
            </div>

            <div class="count_title2">项目(组)保证金</div>
          </div>

          <div class="count_card">
            <div class="count_up">
              <CountUp :end="start_invoice_money" :decimals="2" duration="3" ref="count" v-font="18" />
            </div>

            <div class="count_title">本月期初应收</div>
          </div>

          <div class="count_card">
            <div class="count_up">
              <CountUp :end="current_invioce_money" :decimals="2" duration="3" ref="count" v-font="18" />
            </div>

            <div class="count_title">本月开票</div>
          </div>

          <div class="count_card">
            <div class="count_up">
              <CountUp :end="current_returned_money" :decimals="2" duration="3" ref="count" v-font="18" />
            </div>

            <div class="count_title">本月回款(含预收)</div>
          </div>

          <div class="count_card">
            <div class="count_up">
              <CountUp :end="weihuikuan_money" :decimals="2" :duration="3" ref="count" v-font="18" />
            </div>

            <div class="count_title">本月未回款</div>
          </div>
        </div>


      </div>
    </div>

    <div class="title_text">
      <div>
        <Icon type="ios-bookmark" size="18" color="#0466dd" />
        <span class="title_text2">项目开票</span>
      </div>
    </div>
    <div class="data_div">
      <div class="card_main">
        <div class="count_card3" @click="click_kaipiao">
          <div>
            <span class="iconfont iconjiesuan icon_select"></span>

            <!-- <CountUp :end="interview_data.yaoyue.length" :duration="4" ref="count" v-font="22" /> -->
          </div>

          <div class="count_title2">项目开票申请</div>
        </div>

        <div class="count_card3" @click="click_kaipiao_record">
          <div>
            <span class="iconfont iconjilu icon_select"></span>

            <!-- <CountUp :end="interview_data.yaoyue.length" :duration="4" ref="count" v-font="22" /> -->
          </div>

          <div class="count_title ">历史开票记录</div>
        </div>

        <div class="card_main01">
          <div class="count_card3" @click="click_kaipiao_info">
            <div>
              <span class="iconfont iconkaipiaoxinxi icon_select"></span>
            </div>
            <div class="count_title ">集团开票抬头</div>
          </div>
        </div>
      </div>
    </div>

    <div class="title_text chart_title">
      <div>
        <Icon type="ios-bookmark" size="18" color="#0466dd" />
        <span class="title_text2">结算人数月度折线图</span>
      </div>

      <div class="query_box">
        <span class="chart_tip">{{ jiesuan_count_range_text }}</span>
      </div>
    </div>

    <div class="chart_box">
      <Spin fix v-if="chart_loading"></Spin>
      <div id="jiesuan_count_line_chart"></div>
    </div>

    <div class="chart_source_tip">
      数据来源于开票提交的大湘统一结算表，按归属月，身份证号去重
    </div>

    <!-- <div class="title_text">
      <div>
        <Icon type="ios-bookmark" size="18" color="#0466dd" />
        <span class="title_text2">内部数据支持</span>
      </div>
    </div>
    <div class="data_div">
      <div class="card_main">
        <div class="card_main01">
          <div class="count_card3" @click="click_kaipiao_info">
            <div>
              <span class="iconfont iconkaipiaoxinxi icon_select"></span>
            </div>
            <div class="count_title ">开票与银行一览表</div>
          </div>
        </div>
      </div>
    </div> -->


    <Drawer title="保证金详情" :closable="true" v-model="cash_pledge_show" width="600">
      <div class="bzj_div">
        <Spin size="large" fix v-if="table_loading"></Spin>

        <div class="bzj_div2">
          <Button @click="add_cash_pledge" size="small" style="font-size: 12px" type="primary">
            <Icon type="md-add" />添加保证金
          </Button>
        </div>

        <Table size="small" :columns="cash_pledge_colunms" :data="cash_pledge_table" :height="windowHeight - 140">
        </Table>
      </div>

      <Modal v-model="add_cash_pledge_show" title="添加保证金" :mask-closable="false" :footer-hide="true" width="400">
        <div>
          <div class="">操作类型：</div>

          <Select v-model="add_cash_pledge_data.status" style="width: 300px">
            <Option value="0">支出</Option>

            <Option value="1">收回</Option>
          </Select>

          <div class="add_cash_pledge_title">操作日期：</div>

          <DatePicker v-model="add_cash_pledge_data.date" type="date" placeholder="Select date" style="width: 300px" />

          <div class="add_cash_pledge_title">金额：</div>

          <InputNumber :min="1" v-model="add_cash_pledge_data.money" style="width: 300px" />

          <div class="add_cash_pledge_title">备注：</div>

          <Input v-model="add_cash_pledge_data.remarks" placeholder="请输入备注..." style="width: 300px" />

          <div class="add_cash_div">
            <Button type="primary" @click="click_submit_data">确认</Button>
          </div>
        </div>
      </Modal>
    </Drawer>
  </div>
</template>

<script>
import * as echarts from "echarts";
import { http, open_new_page } from "@/utils/http.js";

export default {
  name: "kaipiao",
  data() {
    return {
      windowWidth: document.documentElement.clientWidth, //实时屏幕宽度
      windowHeight: document.documentElement.clientHeight, //实时屏幕高度
      cash_pledge_balances: 0,
      start_invoice_money: 0,
      current_invioce_money: 0,
      current_returned_money: 0,
      weihuikuan_money: 0,

      loading: false,
      table_loading: false,

      cash_pledge_colunms: [],
      cash_pledge_table: [],
      cash_pledge_show: false,

      add_cash_pledge_show: false,
      add_cash_pledge_data: {
        status: "0",
        date: new Date(),
        money: 0,
        remarks: "",
      },

      current_month: new Date(),

      //结算人数折线图
      chart_loading: false,
      //接口 jiesuan_line_chart 返回的月份与结算人数
      month_title_list: [],
      month_value_list: [],
    };
  },

  created() {
    // echarts 实例不放入 data，避免被 Vue 响应式深度监听导致性能问题
    this.jiesuan_count_chart = null;
  },

  computed: {
    //折线图标题右侧的月份区间提示，如 "2025-09 ~ 2026-09"
    jiesuan_count_range_text() {
      var titles = (this.month_title_list || []).map(String).slice().sort();
      if (!titles.length) {
        return "暂无数据";
      }
      return titles[0] + " ~ " + titles[titles.length - 1];
    },
  },

  mounted() {
    window.addEventListener("resize", this.resize_jiesuan_count_chart);
  },

  beforeUnmount() {
    window.removeEventListener("resize", this.resize_jiesuan_count_chart);
    if (this.jiesuan_count_chart) {
      this.jiesuan_count_chart.dispose();
      this.jiesuan_count_chart = null;
    }
  },

  methods: {
    open(project_id) {
      this.project_id = project_id
      this.get_record_list();
      this.get_jiesuan_line_chart()
    },

    //按月份正序整理数据，保证折线图从左到右按时间递增（接口返回为倒序）
    build_jiesuan_count_chart_data(count_list) {
      var list = count_list || [];

      var pairs = list.map(function (item) {
        return {
          label: String(item.date),
          value: (item.count || []).length,
        };
      });
      // "YYYY-MM" 形式的字符串按字典序排序即为时间正序
      pairs.sort(function (a, b) {
        return a.label < b.label ? -1 : a.label > b.label ? 1 : 0;
      });

      return {
        title_list: pairs.map(function (item) {
          return item.label;
        }),
        count_list: pairs.map(function (item) {
          return item.value;
        }),
      };
    },

    //生成结算人数折线图
    create_jiesuan_count_chart(title_list, count_list) {
      var chartDom = document.getElementById("jiesuan_count_line_chart");
      if (!chartDom) {
        return;
      }

      // 销毁掉原实例，避免重复初始化
      if (this.jiesuan_count_chart) {
        this.jiesuan_count_chart.dispose();
      }

      this.jiesuan_count_chart = echarts.init(chartDom);

      var option = {
        color: ["#0466dd"],
        grid: {
          top: "50px",
          left: "1%",
          right: "3%",
          bottom: "2%",
          containLabel: true,
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "line",
            lineStyle: {
              color: "#0466dd",
              type: "dashed",
            },
          },
          formatter: function (params) {
            var p = params[0];
            return p.axisValue + "<br/>结算人数：<b>" + p.data + "</b> 人";
          },
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: title_list,
          axisTick: {
            show: false,
          },
          axisLine: {
            lineStyle: {
              color: "#e0e0e0",
            },
          },
          axisLabel: {
            color: "#666",
            fontSize: 12,
            interval: 0,
            //月份数量较多时自动隐藏重叠的标签，避免文字挤在一起
            hideOverlap: true,
          },
        },
        yAxis: {
          type: "value",
          name: "人数",
          nameTextStyle: {
            color: "#999",
            fontSize: 12,
          },
          min: function (value) {
            // 让折线变化更明显，同时保留合理刻度
            return Math.floor((value.min * 0.9) / 10) * 10;
          },
          axisLabel: {
            color: "#666",
            fontSize: 12,
          },
          splitLine: {
            lineStyle: {
              type: "dashed",
              color: "#eee",
            },
          },
        },
        series: [
          {
            name: "结算人数",
            type: "line",
            smooth: true,
            symbol: "circle",
            symbolSize: 7,
            showSymbol: true,
            data: count_list,
            lineStyle: {
              width: 2.5,
              color: "#0466dd",
            },
            itemStyle: {
              color: "#0466dd",
              borderColor: "#fff",
              borderWidth: 2,
            },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: "rgba(4,102,221,0.28)" },
                { offset: 1, color: "rgba(4,102,221,0.02)" },
              ]),
            },
          },
        ],
      };

      option && this.jiesuan_count_chart.setOption(option);
    },

    //自适应窗口变化
    resize_jiesuan_count_chart() {
      if (this.jiesuan_count_chart) {
        this.jiesuan_count_chart.resize();
      }
    },

    get_jiesuan_line_chart() {
      console.log('结算---------')
      var that = this;
      var obj = {
        project_id: this.project_id,
      
      };
      this.chart_loading = true;
      http(
        "post",
        process.env.VUE_APP_HOST + "/finance/invoice/jiesuan_line_chart",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            console.log(res);
            var chart_data = that.build_jiesuan_count_chart_data(
              res.data.count_list
            );
            that.month_title_list = chart_data.title_list;
            that.month_value_list = chart_data.count_list;

            that.$nextTick(function () {
              that.create_jiesuan_count_chart(
                chart_data.title_list,
                chart_data.count_list
              );
            });
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
          that.chart_loading = false;
        })
        .catch((res) => {
          that.chart_loading = false;

          console.log(res, "请求出错");
        });
    },

    click_submit_data() {
      if (this.add_cash_pledge_data.money == 0) {
        this.$Message.error("请填写金额");
        return;
      }
      if (this.add_cash_pledge_data.remarks == "") {
        this.$Message.error("请填写备注");
        return;
      }
      var that = this;
      var obj = {
        project_id: this.project_id,
        money: this.add_cash_pledge_data.money,
        date: this.add_cash_pledge_data.date.getTime() / 1000,
        remarks: this.add_cash_pledge_data.remarks,
        status: this.add_cash_pledge_data.status,
      };
      this.table_loading = true;
      http(
        "post",
        process.env.VUE_APP_HOST + "/finance/invoice/add_cash_pledge",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            console.log(res);
            that.cash_pledge_colunms = res.data.columns;
            that.cash_pledge_table = res.data.detail;
            that.add_cash_pledge_show = false;
            that.get_cash_pledge_list();
            that.get_record_list();
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
          that.table_loading = false;
        })
        .catch((res) => {
          that.table_loading = false;

          console.log(res, "请求出错");
        });
    },

    add_cash_pledge() {
      this.add_cash_pledge_show = true;
    },

    click_cash_pledge() {
      this.cash_pledge_show = true;
      this.get_cash_pledge_list();
    },

    //获取保证金详情
    get_cash_pledge_list() {
      var that = this;
      var obj = {
        project_id: this.project_id,
      };
      this.table_loading = true;
      http(
        "post",
        process.env.VUE_APP_HOST + "/finance/invoice/cash_pledge_list",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            console.log(res);
            that.cash_pledge_colunms = res.data.columns;

            that.cash_pledge_table = res.data.detail;
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
          that.table_loading = false;
        })
        .catch((res) => {
          that.table_loading = false;

          console.log(res, "请求出错");
        });
    },

    date_change() {
      this.get_record_list();
    },

    //获取结算历史记录
    get_record_list() {
      console.log("开始获取结算数据");
      var that = this;
      var obj = {
        project_id: this.project_id,
        current_month: Number(this.current_month.getTime() / 1000),
      };
      this.loading = true;
      http("post", process.env.VUE_APP_HOST + "/finance/invoice/jiesuan_heji", obj, true)
        .then((res) => {
          if (res.code == 0) {
            this.cash_pledge_balances = res.data.cash_pledge_balances;
            this.start_invoice_money = res.data.start_invoice_money;
            this.current_invioce_money = res.data.current_invioce_money;
            this.current_returned_money = res.data.current_returned_money;
            this.weihuikuan_money = res.data.weihuikuan_money;
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
          that.loading = false;
        })
        .catch((res) => {
          that.loading = false;

          console.log(res, "请求出错");
        });
    },

    click_kaipiao_info() {
      open_new_page("/tools/public_kaipiao?project_id=" + this.project_id);

    },

    click_kaipiao() {

      open_new_page("/finance/kaipiao?project_id=" + this.project_id);
    },

    click_kaipiao_record() {

      open_new_page("/finance/kaipiao_detail?project_id=" + this.project_id);
    },
  },
};
</script>

<style scoped>
.iconkaipiaoxinxi {
  font-size: 24px;
}

.add_cash_div {
  margin-top: 10px;
  display: flex;
  justify-content: flex-end;
}

.add_cash_pledge_title {
  margin-top: 10px;
}

.bzj_div2 {
  margin-bottom: 10px;
  display: flex;
  justify-content: flex-end;
}

.bzj_div {
  position: relative;
}

.count_up {
  padding-top: 5px;
  height: 33px;
}

.count_card_div {
  display: flex;
  padding: 0 10px;
}

.iconjiesuan {
  font-size: 22px;
  color: #0466dd;
}

.iconjilu {
  font-size: 22px;
}

.icon_select {
  color: #0466dd;

}

.title_text2 {
  font-weight: 600;
}

.export_table {
  font-size: 12px;
  color: #0466dd;
  font-weight: 300;
  margin-right: 10px;
  display: flex;
  align-items: center;
  cursor: pointer;
  letter-spacing: 1px;
}

.title_text {
  margin: 0px 10px 0 10px;
  font-size: 14px;
  color: #333;
  border-bottom: 1px solid #ddd;
  padding: 10px 10px 5px 0px;
  display: flex;
  align-items: center;
  justify-content: left;
  letter-spacing: 2px;
}

.card_main {
  display: flex;
  flex-wrap: wrap;
  margin-top: 10px;
  margin-right: 10px;
}

.card_main01 {
  display: flex;
  flex-wrap: wrap;
  position: relative;
  margin-right: 10px;
}

.count_title2 {
  font-size: 13px;
  margin-top: 5px;
}

.count_title {
  font-size: 13px;
  margin-top: 5px;
}

.count_title10 {
  font-size: 13px;
  color: #fff;
  margin-top: 5px;
}

.count_card {
  margin: 0 10px 10px 0;
  cursor: pointer;
  padding: 5px 10px 10px 10px;
  width: 150px;
  border-radius: 5px;
  border: 1px solid #ececec;
  background-color: #fff;
  text-align: center;
}

.count_card3 {
  margin: 0 10px 10px 0;
  cursor: pointer;
  padding: 5px 10px 10px 10px;
  width: 150px;
  border-radius: 5px;
  border: 1px solid #b8bef7;
  background-color: #fff;
  text-align: center;
}

.count_card3:hover {
  border: 1px solid #0466dd;
  background: #0466dd;
  color: #fff;


}

.count_card3:hover .icon_select {
  color: #fff;
}

.count_card10 {
  margin: 0 10px 10px 0;
  cursor: pointer;
  padding: 5px 10px 10px 10px;
  width: 150px;
  border-radius: 5px;
  background-color: #9add9d;
  text-align: center;
}

.count_card10:hover {
  box-shadow: 0 0 3px #919ea6;
}

.data_div {
  padding: 10px;
  border-radius: 5px;
}

.query_box {
  display: flex;
  margin-left: 20px;
}

.chart_title {
  justify-content: space-between;
}

.chart_title .query_box {
  margin-left: 0;
}

.chart_box {
  position: relative;
  padding: 10px 0px;
  margin: 10px;
  background: #fff;
  border-radius: 5px;
  height: 380px;
}

#jiesuan_count_line_chart {
  width: 100%;
  height: 100%;
}

.chart_tip {
  font-size: 12px;
  color: #999;
  letter-spacing: 1px;
}

.chart_source_tip {
  margin: -6px 10px 10px 10px;
  font-size: 12px;
  color: #999;
  letter-spacing: 1px;
  text-align: right;
}
</style>
